<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-17 15:36:31
 * @LastEditTime: 2023-05-10 14:43:39
 * @Description:
 * @FilePath: \website\src\components\SubMenu.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="menu-bg">
    <el-menu
      :default-active="$router.path"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      text-color="#333333"
      active-text-color="#019845"
    >
      <el-menu-item v-for="(item, index) in menuList" :key="index" :index="item.anchorId"
        >{{item.name}}</el-menu-item
      >
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "SubMenu",
  props: {
    menuList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  methods: {
    handleSelect(index) {
      this.$emit('anchorTo',{id:index})
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.menu-bg {
  position: sticky;
  top: 118px;
  z-index: 1000;
  margin-top: -3.4286rem;
  @include body-padding();
  height: 3.4286rem;
  background: #ffffff;
  opacity: 0.8;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu--horizontal > .el-menu-item {
    width: 100px;
    height: 48px;
    line-height: 48px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SubMenu.vue